// GST state codes as per the official jurisdiction list (used on invoices
// for "Place of Supply" — e.g. "Kerala (32)").
export const INDIAN_STATE_GST_CODES: Record<string, string> = {
  "jammu and kashmir": "01",
  "himachal pradesh": "02",
  punjab: "03",
  chandigarh: "04",
  uttarakhand: "05",
  haryana: "06",
  delhi: "07",
  rajasthan: "08",
  "uttar pradesh": "09",
  bihar: "10",
  sikkim: "11",
  "arunachal pradesh": "12",
  nagaland: "13",
  manipur: "14",
  mizoram: "15",
  tripura: "16",
  meghalaya: "17",
  assam: "18",
  "west bengal": "19",
  jharkhand: "20",
  odisha: "21",
  chhattisgarh: "22",
  "madhya pradesh": "23",
  gujarat: "24",
  "daman and diu": "25",
  "dadra and nagar haveli and daman and diu": "26",
  maharashtra: "27",
  "andhra pradesh (before division)": "28",
  karnataka: "29",
  goa: "30",
  lakshadweep: "31",
  kerala: "32",
  "tamil nadu": "33",
  puducherry: "34",
  "andaman and nicobar islands": "35",
  telangana: "36",
  "andhra pradesh": "37",
  ladakh: "38",
};

/** Returns "Kerala (32)" style label, or just the state name if no code is
 *  found (e.g. free-text entry that doesn't match the official list). */
export const formatStateWithGstCode = (state?: string): string => {
  if (!state) return "-";
  const code = INDIAN_STATE_GST_CODES[state.trim().toLowerCase()];
  return code ? `${state} ( ${code} )` : state;
};
